module.exports = __webpack_public_path__ + "img/picture_viptk07.11086271.png";